module.exports = __webpack_public_path__ + "img/hlsjs.31b147b8.png";